import { faTimesCircle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import * as testConst from 'app/constants/tests';
import { AppStoreState } from 'app/redux/store';
import { checkIsCorrect } from "app/utils/test";
import { useSelector } from 'react-redux';
import { Question } from 'types/test';

interface ResultIconProps {
  question: Question;
  groupType: number;
}

const ResultIcon = (props: ResultIconProps) => {
  const { process } = useSelector((state: AppStoreState) => state.test);

  if (process !== 'complete' || !props.question?.answer || props.groupType == testConst.QUESTION_RADIO) {
    return null;
  }

  const { isCorrect, infoText } = checkIsCorrect(props.question);

  return (
    <>
      {testConst.QUESTION_MULTI == props.question.type && (
        <span>{infoText}</span>
      )}
      <FontAwesomeIcon
        className={`${isCorrect ? 'text-success' : 'text-danger'} mt-5 pl-2`}
        icon={isCorrect ? faCheckCircle : faTimesCircle}
      />
    </>
  )
}

export default ResultIcon;
